import { RouteConfig } from "vue-router";
import { decisionRouteConfig } from "./decision/routeConfig";

export const managementRouteConfig: RouteConfig = {
  path: "organizacja",
  component: {
    render(h) {
      return h("router-view", { key: (this as any).$route.fullPath });
    },
  },
  children: [decisionRouteConfig],
};
